import { ListItemText } from '@material-ui/core'
import { withStyles, makeStyles, createStyles } from '@material-ui/core'

export const StyledListItemText = withStyles({
  primary: {
    color: '#212121',
  },
})(ListItemText)

export const UseStyles = makeStyles((theme) =>
  createStyles({
    nested: {
      paddingLeft: theme.spacing(3),
    },
  }),
)
